module.exports = __webpack_public_path__ + "media/bootstrap-icons/credit-card-2-back-fill-e1471101.svg";